export default __webpack_public_path__ + "static/media/almaz-mangisto.0e13a9c8.png";